<template>
  <li class="student-card-container">
    <div v-show="showUserSettingsMenu" @click="toggleUserSettings" class="dropdown-overlay"></div>
    <button @click="toggleUserSettings" :class="{ 'button-active' : showUserSettingsMenu }" class="user-settings-dropdown_button">
      <i class="fa-light fa-ellipsis-vertical"></i>
    </button>
    <ul v-show="showUserSettingsMenu" ref="userSettingsDropdown" class="user-settings-dropdown">
      <li @click="$emit('editStudent'); toggleUserSettings()" class="user-settings-dropdown_item">
        <p class="user-settings-dropdown_text">Edit</p>
      </li>
      <li @click="$emit('showRemoveStudentModal'); toggleUserSettings()" class="user-settings-dropdown_item">
        <p class="user-settings-dropdown_text has-text-danger">Remove</p>
      </li>
    </ul>
    <div @click="$emit('goToConnectedUser');" class="student-card">
      <div @click="$emit('goToConnectedUser(student.userName)')" class="student-card_avatar" v-bind:style="userAvatar(student.avatar)"></div>
      <span class="user-fullName" v-line-clamp="2">{{ studentName }}</span>
      <span class="user-userName" v-line-clamp="1">{{ student.userName }}</span>
    </div>
  </li>
</template>

<script>
import Vue from 'vue'
import lineClamp from 'vue-line-clamp'
import imageProxy from '@/libs/image-proxy'

Vue.use(lineClamp, {
  textOverflow: 'ellipsis'
})

export default {
  props: ['student'],
  data: function () {
    return {
      showUserSettingsMenu: false
    }
  },
  methods: {
    toggleUserSettings: function () {
      this.showUserSettingsMenu = !this.showUserSettingsMenu
    },
    userAvatar: function (avatar) {
      const style = {}
      const proxiedAvatar = imageProxy.proxy(avatar, { width: 100, height: 100 })
      style.backgroundImage = `url('${proxiedAvatar}')`
      return style
    }
  },
  computed: {
    studentName: function () {
      return `${this.student.firstName} ${this.student.lastName}`
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';

.dropdown-overlay {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 1;
  background: transparent;
  height: 100vh;
  width: 100vw;
}

.student-card-container {
  position: relative;
}

.student-card {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  text-align: center;
  margin: 1em 1em 1em 0;
  padding: 0.5rem;
  border-radius: 1.5rem;
  background: white;
  transition: all 0.2s;
  min-height: fit-content;
  height: 14rem;
  width: 11rem;
  &_container {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    @include touch {
      justify-content: center;
    }
  }
  &_icon {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    cursor: pointer;
    padding-bottom: .5rem
  }
  &_avatar {
    position: relative;
    cursor: pointer;
    max-height: 150px;
    margin: 0.5rem;
    background-size: cover;
    background-position: center;
    height: 8rem;
    width: 8rem;
    border-radius: 50%;
  }
}

.user {
  &-fullName {
    color: black;
    font-size: 1rem;
    font-weight: 600;
  }
  &-userName {
    font-size: 0.75rem;
    font-weight: 400;
  }
}

.user-settings-dropdown {
  background: white;
  position: absolute;
  top: 22.5%;
  right: -14%;
  z-index: 2;
  text-align: left;
  padding: 0.2rem 0.5rem;
  width: fit-content;
  box-shadow: 0px 2px 3px 1px #d2d2d2;
  cursor: pointer;
  &_item {
    margin: 0.5rem;
  }
  &_button {
    position: absolute;
    z-index: 2;
    top: 9%;
    right: 13%;
    border-radius: 50%;
    width: 2rem;
    height: 2rem;
    background: transparent;
    border: none;
    cursor: pointer;
    &:hover {
      background: #F0F0F0;
    }
  }
  &_text {
    display: inline-block;
  }
}

.button-active {
  background: #F0F0F0;
}

.button-icon-container {
  position: absolute;
  display: flex;
  bottom: 39%;
  left: 5%;
  width: 100%;
  justify-content: center;
  span {
    margin-right: 0.5rem;
  }
}
.edit a {
  color: white;
}

i.action-icon {
  display: block;
  border-radius: 60px;
  padding: 0.5em 0.6em;
  color: white;
}

i.delete-icon {
  background-color: $primary;
  &:hover {
    box-shadow: 0 0rem 1rem white;
    font-size: 0.95rem;
  }
}

.edit-icon {
  background-color: black;
  margin-right: 0.5rem;
  &:hover {
    box-shadow: 0 0rem 1rem white;
    font-size: 0.95rem;
  }
}

.student-card-overlay {
  background-color: rgb(0, 0, 0, 0.35);
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}
</style>
